import Service from '@ember/service';
import { task, timeout } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { waitForEvent } from 'ember-concurrency';
export default class ModifierKeysService extends Service {
  @tracked meta = false;
  @tracked alt = false;
  @tracked shift = false;
  @tracked ctrl = false;

  constructor() {
    super(...arguments);
    this.monitorKeyDown.perform();
    this.monitorKeyUp.perform();
  }

  monitorKeyUp = task(async () => {
    while (true) {
      await waitForEvent(document, 'keyup');
      this.meta = false;
      this.alt = false;
      this.shift = false;
      this.ctrl = false;
 
      await timeout(25);
    }
  });

  monitorKeyDown = task(async () => {
    while (true) {
      let event = await waitForEvent(document, 'keydown');
      this.meta = event.metaKey;
      this.alt = event.altKey;
      this.shift = event.shiftKey;
      this.ctrl = event.ctrlKey;
 
      await timeout(25);
    }
  });
}